import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
  title,
  description,
  keywords,
  canonical,
  type = 'website',
  schemaData = null,
}) => {
  const baseUrl = process.env.REACT_APP_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : '');
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;

  // Inject JSON-LD schemas imperatively (react-helmet v6 drops <script> children in production builds).
  useEffect(() => {
    if (!schemaData) return undefined;
    const schemas = Array.isArray(schemaData) ? schemaData : [schemaData];
    const nodes = schemas.map((schema, idx) => {
      const el = document.createElement('script');
      el.type = 'application/ld+json';
      el.setAttribute('data-seo-schema', String(idx));
      el.text = JSON.stringify(schema);
      document.head.appendChild(el);
      return el;
    });
    return () => {
      nodes.forEach((n) => n.parentNode && n.parentNode.removeChild(n));
    };
  }, [schemaData]);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={`${baseUrl}/logo-512.png`} />
      <meta property="og:site_name" content="Snake Catchers Bangalore" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${baseUrl}/logo-512.png`} />

      {/* Local business */}
      <meta name="geo.region" content="IN-KA" />
      <meta name="geo.placename" content="Bangalore" />
    </Helmet>
  );
};

export default SEO;
